export default "__VITE_ASSET__BQ50n$Uu__"